import { Flex, Text, Textarea } from "@chakra-ui/react";

const TextAreaCustom = ({ label, errors, touched, ...props }) => {
  return (
    <>
      <Flex justifyContent="space-between" w="100%"
      flexDir={'column'}
      >
        <Text mr="20px" minW="80px">
          {label}
        </Text>
        <Textarea {...props} />
      </Flex>
      <Flex minH="40px" color={"red.500"}>
        {errors && touched && errors}
      </Flex>
    </>
  );
};

export default TextAreaCustom;
